import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { contextIdSymbol, PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { ITpaContextMapping, TpaContextMappingSymbol } from 'feature-tpa-commons'
import { getFullId } from '@wix/thunderbolt-commons'
import type { ComponentWillMount, ViewerComponent } from 'feature-components'
import type { TpaPageConfig } from '../types'
import { TPA_COMPONENTS } from '../constants'
import * as ResponsiveChatUtils from '../utils/responsiveChatUtils'
import { name } from '../symbols'

export const TpaComponentWillMountExtension = withDependencies(
	[contextIdSymbol, TpaContextMappingSymbol, named(PageFeatureConfigSymbol, name)],
	(
		contextId: string,
		tpaContextMapping: ITpaContextMapping,
		tpaPageConfig: TpaPageConfig
	): ComponentWillMount<ViewerComponent> => {
		return {
			componentTypes: TPA_COMPONENTS,
			componentWillMount(comp) {
				const tpaCompData = tpaPageConfig.widgets[comp.id] || tpaPageConfig.widgets[getFullId(comp.id)]
				const uniqueOrTemplateId = ResponsiveChatUtils.getTemplateOrUniqueId(comp.id, tpaCompData)
				if (comp.id !== uniqueOrTemplateId) {
					tpaContextMapping.registerTpaTemplateId(uniqueOrTemplateId, comp.id)
				}
				tpaContextMapping.registerTpasForContext({ contextId, pageId: tpaPageConfig.pageId }, [
					uniqueOrTemplateId,
				])
			},
		}
	}
)
